// CommonJS exports for backward compatibility with gatsby-config.js
const utils = require('@repo/utils')

// Re-export all website URL utilities
module.exports = {
  useLocalePathPrefix: utils.useLocalePathPrefix,
  useAppPathPrefix: utils.useAppPathPrefix, 
  pathPrefix: utils.pathPrefix,
  bucketPrefix: utils.bucketPrefix,
  getWebsiteUrl: utils.getWebsiteUrl, 
  getWebsitePathPrefix: utils.getWebsitePathPrefix,
  getPathNavigation: utils.getPathNavigation
}
